import NetInfo, { addEventListener } from "@react-native-community/netinfo";
import React, { useEffect, useState } from "react";
import { Modal, StatusBar, Text, View, StyleSheet } from "react-native";
import ManInSpace from "@assets/svg/ManInSpace";
import Button from "./Button";

import t from "../constants/localization";

const PATH = "components/NetworkIndicator";

const NetworkIndicator = () => {
  const [isConnected, setIsConnected] = useState(true);

  useEffect(() => {
    const unsubscribe = addEventListener((state) => {
      if (state.isInternetReachable === false) {
        setIsConnected(false);
      } else {
        setIsConnected(true);
      }
    });
    return () => unsubscribe();
  }, []);

  const onPress = () => {
    NetInfo.fetch().then((state) => {
      setIsConnected(state.isInternetReachable);
    });
  };

  return (
    <>
      {!isConnected && <StatusBar barStyle="dark-content" />}
      <Modal
        statusBarTranslucent
        navigationBarTranslucent
        visible={!isConnected}
        animationType="fade"
      >
        <View style={styles.container}>
          <ManInSpace />
          <Text style={styles.title}>{t(`${PATH}/noInternet`)}</Text>
          <Text style={styles.subtitle}>{t(`${PATH}/noInternetMsg`)}</Text>
          <Button
            btnText={t(`${PATH}/tryAgain`)}
            buttonStyle={styles.btnStyle}
            buttonWidth={220}
            borderRadius={10}
            textStyle={styles.btnTextStyle}
            onPress={onPress}
          />
        </View>
      </Modal>
    </>
  );
};

export default NetworkIndicator;

const styles = StyleSheet.create({
  container: {
    backgroundColor: "white",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  btnStyle: {
    paddingHorizontal: 36,
    paddingVertical: 15,
    height: undefined,
    marginTop: 40,
  },
  btnTextStyle: {
    fontSize: 20,
  },
  title: {
    fontSize: 24,
    fontFamily: "NotoSansDevanagari-Bold",
  },
  subtitle: {
    fontFamily: "NotoSansDevanagari-Regular",
    width: "70%",
    textAlign: "center",
  },
});
